// TOP LEVEL IMPORTS
import React from 'react';
import styled from 'styled-components';
// COMPONENTS
import SectionHeader from 'components/text/SectionHeader';
import LinkText from 'components/text/LinkText';

const Container = styled.div`
  padding-bottom: 40px;
  padding-top: 10px;
`;

const StyledLinkText = styled(LinkText)`
  display: inline;
`;

const AdminSection = ({
  label, children, onEdit, onEditText,
}) => (
  <Container>
    <div>
      <SectionHeader>{label}</SectionHeader>
      {onEdit && onEditText && <StyledLinkText onClick={onEdit}>{onEditText}</StyledLinkText>}
    </div>
    <div>{children}</div>
  </Container>
);

AdminSection.defaultProps = {
  onEdit: null,
  onEditText: 'edit',
};

export default AdminSection;



// WEBPACK FOOTER //
// ./src/components/common/AdminSection/index.js